import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-sketch font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border-2 relative",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground border-[var(--sketch-border)] shadow-[3px_3px_0px_rgba(0,0,0,0.15)] hover:shadow-[4px_4px_0px_rgba(0,0,0,0.2)] hover:translate-y-[-2px] active:shadow-[1px_1px_0px_rgba(0,0,0,0.15)] active:translate-y-0",
        destructive:
          "bg-destructive text-destructive-foreground border-[var(--sketch-border)] shadow-[3px_3px_0px_rgba(0,0,0,0.15)] hover:shadow-[4px_4px_0px_rgba(0,0,0,0.2)] hover:translate-y-[-2px]",
        outline:
          "border-[var(--sketch-border)] bg-background text-foreground shadow-[2px_2px_0px_rgba(0,0,0,0.1)] hover:bg-accent hover:text-accent-foreground hover:shadow-[3px_3px_0px_rgba(0,0,0,0.15)] hover:translate-y-[-1px]",
        secondary:
          "bg-secondary text-secondary-foreground border-[var(--sketch-border)] shadow-[2px_2px_0px_rgba(0,0,0,0.1)] hover:bg-secondary/80 hover:shadow-[3px_3px_0px_rgba(0,0,0,0.15)]",
        ghost: "hover:bg-accent hover:text-accent-foreground border-transparent",
        link: "text-primary underline-offset-4 hover:underline border-transparent",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-9 rounded-lg px-3 text-xs",
        lg: "h-11 rounded-lg px-8 text-base",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
